module.exports = __webpack_public_path__ + "img/Proactivity_Ultra.7f744d6c.png";